import { render, staticRenderFns } from "./box6.vue?vue&type=template&id=5ab233b4&scoped=true"
import script from "./box6.vue?vue&type=script&lang=js"
export * from "./box6.vue?vue&type=script&lang=js"
import style0 from "./box6.vue?vue&type=style&index=0&id=5ab233b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab233b4",
  null
  
)

export default component.exports